import { createSlice } from '@reduxjs/toolkit';
const parametersSlice = createSlice({
    name: 'supervisor',
    initialState: {
        connected: false,

        //CONFIG
        showDisconnectedAgents: false,
        hideMissedOnWelcome: false,
        hideMissedOnQueue: false,
        onlyOpengroupCalls: false,
        showOnly: 0,
        refreshTime: 0,
        record: false,
        ///ALARMS
        timeInQueue: 0,
        maxConversation: 0,
        maxPauseTime: 0,
        maxDroppedCalls: 0,
        callDuration: 0,
        callPeriod: 0,
        dialersActivity: 0,
        formOpenWithoutActivity: 0,
        excludeAgents: [],
        notify: false,
        notifyAudio: false,
        rtl: false



    },
    reducers: {
        setConnected: (state, action) => {
            state.connected = action.payload;
        },
        setConfig(state, action) {
            if (action.payload) {

                state.showDisconnectedAgents = action.payload.showDisconnectedAgents;
                state.hideMissedOnWelcome = action.payload.hideMissedOnWelcome;
                state.hideMissedOnQueue = action.payload.hideMissedOnQueue;
                state.onlyOpengroupCalls = action.payload.onlyOpengroupCalls;
                state.showOnly = action.payload.showOnly;
                state.refreshTime = action.payload.refreshTime;
            }
        },
        setAlarms(state, action) {
            if (action.payload) {

                state.timeInQueue = action.payload.timeInQueue;
                state.maxConversation = action.payload.maxConversation;
                state.maxPauseTime = action.payload.maxPauseTime;
                state.maxDroppedCalls = action.payload.maxDroppedCalls;
                state.callDuration = action.payload.callDuration;
                state.callPeriod = action.payload.callPeriod;
                state.dialersActivity = action.payload.dialersActivity;
                state.formOpenWithoutActivity = action.payload.formOpenWithoutActivity;
                state.excludeAgents = action.payload.excludeAgents || [];
                state.notify = action.payload.notify;
                state.notifyAudio = action.payload.notifyAudio;
            }
        },
        setRecord(state, action) {
            state.record = action.payload;
        },
        setRTL(state, action) {
            state.rtl = action.payload;
        }
    }
});

export default parametersSlice.reducer
export const { setConnected, setConfig, setAlarms, setRecord, setRTL } = parametersSlice.actions
